module.exports = __webpack_public_path__ + "img/flot-fyr-paa-snap-2.23f06954.png";